<template>
    <div class="header">
        
        <div class="lms">
            <div v-if="(Object.hasOwnProperty.call(userInfo,'username'))" class="no-login">
                {{userInfo.username}}
                <div class="list">
                    <ul>
                        <!-- <a href="/check"><li>资格审核</li></a>
                        <a v-if="Number(userInfo.type)===0" href="/applyExam"><li>考试申请</li></a> -->
                        <li @click="$router.push('/profile')">个人中心</li>
                        <li @click="loginOut">退出登录</li>
                    </ul>
                </div>
            </div>
            <div v-if="!(Object.hasOwnProperty.call(userInfo,'username'))" class="no-login">
                <a href="/login">
                    <img src="../assets/login.png"><span>登录</span>
                </a>
            </div>
            <div class="logo">
                <a href="/">
                    <img :src="globalObj.logo.image">
                </a>
            </div>
            <div class="lx-search">
                <div class="nav">
                    <div class="main">
                    <ul class="navUL">
                        <li>
                            <a href="/">首页</a>
                        </li>
                        <li class="sec-nav"> 
                            <a href="/aboutISOC" title="关于协会">
                                关于协会 
                                <!-- <i class="fa icon-arrow-down"></i> -->
                            </a>
                            <!-- <div class="naverj" style="display: none; opacity: 1;">
                                <a href="/certificate?type=1" title="招生简章"> 招生简章 </a>
                                <a href="/certificate?type=2" title="证书样本"> 证书样本 </a>
                            </div>       -->
                        </li>
                        <li class="sec-nav"> 
                            <a href="/ifmExam" title="IFM考试">
                                IFM考试 
                                <!-- <i class="fa icon-arrow-down"></i> -->
                            </a>  
                        </li>
                        <li class=""> 
                            <a href="/info?type=0" title="新闻中心">新闻中心</a>
                        </li>
                        <li class=""> 
                            <a title="学习系统">学习系统</a>
                            <div class="naverj" style="display: none; opacity: 1;">
                                <a href="/course?type=0" title="课程学习"> 课程学习 </a>
                                <a href="/course?type=1" title="电子书"> 电子书 </a>
                                <!-- <a href="/exam?type=0" title="模拟考试" target="_blank"> 模拟考试 </a> -->
                            </div>   
                        </li>
                        <li class=""> 
                            <a href="/myexams" title="考试系统">考试系统</a>
                        </li>
                        <li class="sec-nav"> 
                            <a href="/authorizedUnit" title="IFM会员">
                                IFM雇主 
                                <!-- <i class="fa icon-arrow-down"></i> -->
                            </a>
                        </li>
                        <li class=""> 
                            <a href="/enrollStudent" title="授权机构">授权机构</a>
                        </li>
                        <li class="sec-nav"> 
                            <a href="/certificateQuery" title="证书查询">
                                证书查询 
                                <!-- <i class="fa icon-arrow-down"></i> -->
                            </a>
                        </li>
                        <li class=""> 
                            <a href="/contact" title="联系我们">联系我们</a>
                        </li>
                    </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="top_r">
                <div class="page-header-member" id="dr_member_info">
                    <div class="user_info"> 
                        <a v-if="!(Object.hasOwnProperty.call(userInfo,'username'))" href="/register">报名入口</a>
                        <div v-if="(Object.hasOwnProperty.call(userInfo,'username'))" class="name">
                            {{userInfo.username}}
                            <div class="list">
                                <ul>
                                    <a href="/check"><li>资格审核</li></a>
                                    <a v-if="Number(userInfo.type)===0" href="/applyExam"><li>考试申请</li></a>
                                    <li @click="loginOut">退出登录</li>
                                </ul>
                            </div>
                        </div>  
                        
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'userInfo',
        'logoImg',
        'globalObj'
    ]),
    methods: {
        loginOut(){
            this.$store.commit('LOGIN_OUT',this.$toast);
        }
    },
}
</script>
<style lang="scss" scoped>
.no-login{
    position: absolute;
    right: 20px;
    top:-31px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0.4px;
    font-weight: 400;
    img{
        width: 18px;
        height: 18px;
        margin-right: 8px;
        vertical-align: middle;
    }
    span{
        display: inline-block;
        vertical-align: middle;
        color: #333333;
    }
}
.list{
        display: none;
        position: absolute;
        top: 19px;
        left:5px;
        z-index: 999;
        li{
            width:100px;
            text-align: center;
        }
    }
.no-login:hover .list{
        display: block;
        background: #fff;
        cursor: pointer;
        padding:5px;
        box-shadow:0 -2px 4px rgba(0,0,0,.2);
        li:hover{
            background:#ff7700;
            color:#fff;
        }
    }

a,a:link { cursor:pointer; color: #FFF;text-decoration: none;}
a:hover{ text-decoration: none; color:#04407D;}
.header{
    width:100%; 
    height:154px; 
    padding-top: 40px;
    box-sizing: border-box;
    background: #F0F0F0;
    position: relative;
}
.main {
    clear: both;
    width: 1200px;
    margin: 0 auto;
}
.lms{
        width:1120px; 
        height:114px;margin:0px auto;
        background: #fff;
        position: relative;
        }
    .logo{
            float:left; height:68px;width:210px;
            margin-top: 20px;
    margin-left: 29px;
        }
    .logo img{ height:68px;width:100%}

        .lx-search { width:600px;float:left; position:relative; margin-left:12px; padding-top:29px; }
        .lx-search .search-txt {  width:340px; height:35px; border:1px solid #cfcfcf; background:#f7f5f5; padding-left:12px; -webkit-border-radius:5px; -moz-border-radius:5px; border-radius:5px; font:14px "Microsoft YaHei"; /*safari垂直居中*/line-height:normal;}
        .lx-search .search-btn {width:80px; height:39px; display:block; position:absolute; right:0; top:0; border:0; background:#ff7700; color:#fff; -webkit-border-radius:5px; -moz-border-radius:5px; border-radius:5px; -webkit-appearance:none; font:16px/35px "Microsoft YaHei"; cursor:pointer}


        .nav {}
        .navUL li{ float: left; text-align: center;height: 60px; line-height:50px; font-size: 16px; color: #fff;position: relative; width:85px; }
        .navUL a { font-family: PingFangSC-Semibold;
font-size: 16px;
color: #333333; font-weight: 600;}
        .navUL li:hover a{color:#133567;}
        .navUL li:hover .naverj{display: block !important;}
        .naverj{ position: absolute; top:50px; border-radius:10PX; padding:10PX 0; background-color: rgba(218,235,247,0.9); border-bottom:3px solid #405d9e; min-width:160px; margin-left:-30PX; display: none; z-index:9999; }
        .naverj a {font-size: 16px; color: #133567; height:45px; line-height:45px;display:block;}
        .naverj a:hover{ color: #fff !important; background:#224899; text-decoration: none; }

        .naverjlast{ margin-left:-50px;}

        .nav { position: relative; }

.header .top_r {
    float: right;
    width: 150px;
    height: 50px;
    font-size: 16px;
    padding-top: 15px;
    position: relative;
}
.header .top_r .def-nav{ 
    width:150px; float:right; text-decoration:none;
}
.header .top_r a,a:link{
    color:#333;
}
.header .top_r .def-nav a{ text-decoration:none;}
.header .top_r .def-nav a.hover{ border-left:1px #ddd solid; border-right:1px #ddd solid; text-align:center; background:#FFF;}

</style>
